<template>
  <div>
    <div class="spo-card pa-2 rounded mb-2">
      <div class="d-flex justify-space-between align-items-center mb-2 flex-wrap">
        <div class="text-h6 text-darkblue">
          <b>Pass Prévention Santé (PPS)</b> - <span v-if="status.includes('revenir')">(PPS à réaliser à partir du
            {{ date_validite_pps }})</span><span v-else>(Validité de 1 an)</span>
        </div>
        <div class="d-flex align-items-center ga-2">
          <SportipsButton v-if="!status.includes('revenir')" href="https://pps.athle.fr/" target="_blank"
            icon="mdi-file-document" chevron secondary-action-button>Faire mon PPS
          </SportipsButton>

        </div>
      </div>
      <div>
        <SportipsButton @click="toggleDetails" icon="mdi-information-variant" class="bg-white mb-2">
          {{ showDetails ? 'Moins de détails' : 'Plus de détails' }}
        </SportipsButton>
      </div>

      <transition name="slide-fade" class="my-2">
        <div v-show="showDetails" class="more-info-section">
          <div v-if="status == 'pps_and_certif'">Afin de valider votre inscription, vous pourrez fournir <b>un
              certificat
              médical, ou votre numéro de PPS</b>.</div>
          <div v-if="status == 'pps'">Afin de valider votre inscription, vous pourrez fournir <b>votre numéro de
              PPS</b>.
          </div>
          <div v-if="status == 'pps_revenir'">
            <b>Votre PPS est valable 1 an</b> Vous devrez réaliser votre PPS à partir du : <b>{{ date_validite_pps
            }}</b><br />
            Si vous avez déjà un numéro d'attestation PPS, il vous faudra à nouveau suivre le Pass Prévention
            Santé.<br />
            Inscrivez-vous dès maintenant, nous vous enverrons un rappel dès le {{ date_validite_pps }} pour effectuer
            votre
            PPS et indiquer le numéro d'attestation délivré dans votre fiche d'inscription. Votre inscription sera
            validée.
            (<b>La vérification est automatique, pensez à vérifier la saisie de vos nom et prénom à l'identique</b>)
          </div>

          <div class="d-flex justify-center">
            <img class="px-2 pa-2" style="max-width: 100%;" v-if="with_image"
              v-bind:src="require('@/assets/img/pps.png')" />
          </div>
          <hr />
          <div class="text-h6 text-darkblue">Foire aux questions</div>
          <v-expansion-panels>
            <v-expansion-panel elevation="0">
              <v-expansion-panel-title>
                <p class="my-2">Le PPS, c'est quoi?</p>
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <p>Le Pass Prévention Santé (PPS), mis en place par la Fédération Française d’Athlétisme dans le
                  cadre
                  de la loi « Sport » du 2 mars 2022, révolutionne le processus d'inscription aux courses running en
                  France.
                </p>
                <p>
                  Pour les participants, il remplace le traditionnel certificat médical d'aptitude à la pratique
                  sportive et simplifie ainsi les démarches d'inscription. Désormais, tout participant majeur souhaitant
                  s’inscrire à une course
                  running devra suivre le PPS en ligne sur la plateforme dédiée pps.athle.fr, dans les 12 mois
                  précédant
                  la compétition. Ce parcours vise à sensibiliser les coureurs aux risques, précautions et
                  recommandations
                  liés à la pratique de la
                  course à pied, à travers du contenu pédagogique comprenant texte et vidéo.
                </p>
                <p>Pour les mineurs, vous devrez compléter un questionnaire de santé sur la plateforme dédiée
                  pps.athle.fr. A l'issue du questionnaire, vous recevrez un numéro de PPS valide pour la course</p>
                <p>
                  Les licenciés FFA, ayant déjà suivi le PPS pour leur prise de licence, sont exemptés de cette
                  démarche avant chaque course. Le parcours en ligne sensibilise les participants à diverses
                  problématiques telles que les signaux d'alerte, les précautions selon l'âge, l'importance de consulter
                  un
                  médecin en cas de risques
                  identifiés, et l'incitation à se former aux gestes qui sauvent. À la fin du PPS, le participant peut
                  obtenir une attestation à remettre à l'organisateur avant la course.
                </p>
                <p>
                  Le déploiement du PPS sur l'ensemble des courses running se fait progressivement d'avril à août 2024,
                  pour
                  une application obligatoire à partir du 1er septembre 2024. Un échéancier a été établi en fonction des
                  dates d'ouverture des
                  inscriptions et des dates des compétitions pour chaque événement.
                </p>
              </v-expansion-panel-text>
            </v-expansion-panel>
            <v-expansion-panel elevation="0">
              <v-expansion-panel-title>
                <p class="my-2">Puis-je fournir un certificat médical ou mon PPS ?</p>
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <div>Le certificat médical n'est plus accepté pour les courses. Vous devrez
                  fournir le numéro de votre dernier PPS (moins de 1 an) pour valider votre
                  inscription.</div>
              </v-expansion-panel-text>
            </v-expansion-panel>
            <v-expansion-panel elevation="0">
              <v-expansion-panel-title>
                <p class="my-2">Ai-je besoin du PPS?</p>
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <ul>
                  <li>Licenciés FFA pas besoin du PPS</li>
                  <li>Pas de changement pour les licenciés FFA, on valide votre inscription automatiquement avec votre
                    numéro de licence.</li>

                </ul>
              </v-expansion-panel-text>
            </v-expansion-panel>
            <v-expansion-panel elevation="0">
              <v-expansion-panel-title>
                <p class="my-2">Comment obtenir mon numéro de PPS?</p>
              </v-expansion-panel-title>
              <v-expansion-panel-text> Il vous suffit de suivre la procédure sur le site <a href="https://pps.athle.fr/"
                  target="_blank">pps.athle.fr</a>. </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </transition>


      <div v-if="mainStore.module && (mainStore.module.base == 'VVX26' || mainStore.module.base == 'VVX27')">
        <b> L'organisation rappelle que le trail constitue un effort important et conséquent. Il est donc vivement
          conseillé aux personnes présentant des pathologies cardiaques ou respiratoires de consulter un médecin avant
          de participer à l’événement.</b>
      </div>






    </div>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";

export default {
  props: {
    with_image: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showDetails: false
    };
  },
  computed: {
    ...mapStores(useMainStore),
    date_validite_pps() {
      return this.$moment(this.mainStore.module.evenement.date_fin).subtract(12, "months").format("DD/MM/YYYY");
    },

    status() {
      let status = "pps";
      const date_fin = this.mainStore.module.evenement.date_fin;
      if (this.$moment(date_fin).diff(this.$moment(), "months") >= 12) {
        status += "_revenir";
      }
      return status;
    },
  },
  methods: {
    toggleDetails() {
      this.showDetails = !this.showDetails;
    }
  },
};
</script>

<style lang="scss">
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter-from {
  transform: translateY(-10px);
  opacity: 0;
}

.slide-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}

.more-info-section {
  overflow: hidden;
}
</style>